import { useEffect, useState } from 'react'
import { Modal, Spin, Switch } from 'antd'

import { updateOrgMobileApplyStatus } from '../../../common/request'
import ResponseCode from '../../../common/response-code'

function SettingOrgConfiguration ({ orgItem, onUpdated }) {
  const [mobileApplyEnabled, setMobileApplyEnabled] = useState(true)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setMobileApplyEnabled(orgItem?.orgMobileApplyStatus !== 0)
  }, [orgItem])

  const toggleMobileApplyChange = (status) => {
    Modal.confirm({
      title: '操作确认',
      content: `确认${status ? '开启' : '关闭'}机构级移动端报名？`,
      onOk: () => {
        setLoading(true)
        updateOrgMobileApplyStatus({
          id: orgItem.id,
          orgMobileApplyStatus: status ? 1 : 0
        }).then(res => {
          if (res.code === ResponseCode.success) {
            Modal.success({
              title: '操作成功',
              content: `已${status ? '开启' : '关闭'}机构级移动端报名`
            })
            onUpdated?.()
          } else {
            Modal.error({
              title: '操作失败',
              content: res.msg
            })
          }
        }).catch(() => {
          Modal.error({
            title: '网络错误',
            content: '更新配置失败'
          })
        }).finally(() => {
          setLoading(false)
        })
      }
    })
  }

  return (
    <Spin spinning={ loading }>
      <div className="py-2">
        <div className="d-flex align-items-center">
          <div style={ { minWidth: 280 } }>移动端报名：</div>
          <Switch
            checked={ mobileApplyEnabled }
            checkedChildren="开启"
            unCheckedChildren="关闭"
            onChange={ toggleMobileApplyChange }
          ></Switch>
        </div>
      </div>
    </Spin>
  )
}

export default SettingOrgConfiguration
